import {TranslatePipe} from '@ngx-translate/core';
import {Component, inject, Input, OnInit} from '@angular/core';
import {ShoppingService} from '@app/common/services/shopping.service';
import {AppStateService} from '@app/common/services/app-state.service';

@Component({
  selector: 'app-prices-table',
  templateUrl: './prices-table.component.html',
  styleUrls: ['./prices-table.component.scss'],
  imports: [
    TranslatePipe
  ]
})
export class PricesTableComponent implements OnInit {
  public readonly settingsService = inject(AppStateService);
  public readonly shoppingService = inject(ShoppingService);

  @Input() price = 0;
  @Input() groupPrice = 0;
  @Input() totalTable = false;
  public math = Math;

  ngOnInit() {
  }

}
